import { fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import { reducer as form } from 'redux-form/immutable';
import { localization, bootstrap as bootstrapLocalization } from 'epic-localization/src/client/reducers/localization.reducer';
import user from './UserReducer';
import config from './ConfigReducer';
import payout from './PayoutReducer';
import redeem from './RedeemReducer';
import prize from './PrizeReducer';
import taxProfile from './TaxProfileReducer';
import participation from './ParticipationReducer';
import legal from './LegalReducer';
import epicGamesHeader from './EpicGamesHeaderReducer';
import epicGamesFooter from './EpicGamesFooterReducer';

const reducers = {
    form,
    localization,
    user,
    config,
    payout,
    redeem,
    prize,
    taxProfile,
    participation,
    legal,
    epicGamesHeader,
    epicGamesFooter
};

const bootstrapReducers = [bootstrapLocalization];

export function bootstrap(dataPreload) {
    let bootstrapState = fromJS({});
    for (const bootstrapReducer of bootstrapReducers) {
        bootstrapState = bootstrapState.merge(bootstrapReducer(dataPreload));
    }
    bootstrapState = bootstrapState.merge({
        config: dataPreload.config,
        user: dataPreload.user,
        legal: dataPreload.legal,
        epicGamesHeader: dataPreload.epicGamesHeader,
        epicGamesFooter: dataPreload.epicGamesFooter
    });
    return bootstrapState;
}

export function createReducer(extraReducers) {
    return combineReducers({
        ...reducers,
        ...extraReducers
    });
}
